import React from "react";
import PendingEmailCampaignPage from "../../../components/Pages/Campaign/PendingOrder/Email";

const PendingEmailCampaign = () => {
  return (
    <div>
      <PendingEmailCampaignPage />
    </div>
  );
};

export default PendingEmailCampaign;
